import { lazy, type LazyExoticComponent } from 'react';

import type {
	ActionRendererFor,
	ReadOnlyActionRendererFor,
} from '@atlassian/conversation-assistant-message-actions-api/types';

export const AskQuestionRendererAsync: LazyExoticComponent<
	(props: ActionRendererFor<'ask_question'>) => React.JSX.Element
> = lazy(() =>
	import(
		/* webpackChunkName: "@atlassian/conversation-assistant-message-actions/ask-question-renderer" */ './AskQuestionRenderer'
	).then((m) => ({ default: m.AskQuestionRenderer })),
);

export const AskQuestionReadOnlyRendererAsync: LazyExoticComponent<
	(props: ReadOnlyActionRendererFor<'ask_question'>) => React.JSX.Element | null
> = lazy(() =>
	import(
		/* webpackChunkName: "@atlassian/conversation-assistant-message-actions/ask-question-readonly-renderer" */ './AskQuestionRenderer'
	).then((m) => ({ default: m.AskQuestionReadOnlyRenderer })),
);
